import { useEffect, useState } from 'react'
import { lookupAwareness } from '../repository/awarenessRepository'
import type { ConsumerAwareness } from '@/types/crm'

/**
 * Cross-checks a set of contact emails against the consumer skida.app project.
 *
 * `pending` is true until the first answer arrives — the UI must not claim
 * "New to Skida" while the lookup is still in flight, since that would show the
 * wrong (longer, educational) template to someone who does know Skida.
 */
export function useAwareness(emails: string[]) {
  const [awareness, setAwareness] = useState<Map<string, ConsumerAwareness>>(new Map())
  const [pending, setPending] = useState(emails.length > 0)

  // Join into a stable key so the effect does not refire on array identity alone.
  const key = emails
    .map((e) => e.trim().toLowerCase())
    .sort()
    .join(',')

  useEffect(() => {
    if (!key) {
      setAwareness(new Map())
      setPending(false)
      return
    }
    let cancelled = false
    setPending(true)
    lookupAwareness(key.split(','))
      .then((result) => {
        if (!cancelled) setAwareness(result)
      })
      .finally(() => {
        if (!cancelled) setPending(false)
      })
    return () => {
      cancelled = true
    }
  }, [key])

  return { awareness, pending }
}
